import {useState} from 'react';

import {Button} from '@/components';

import UploadPoolTransactionModal from './UploadPoolTransactionModal';

const UploadPoolTransactionButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        variant="solid"
        colorScheme="cyan"
        onClick={() => setIsOpen(true)}
        data-cy="pool-upload-open"
      >
        Upload Pool Transaction
      </Button>
      <UploadPoolTransactionModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default UploadPoolTransactionButton;
